export default __webpack_public_path__ + "static/aquarate-734f293768c648ee7007b6970dafa2c6.svg";